export enum ContextModuleChainID {
  Ethereum = "ethereum",
  Solana = "solana",
  Concordium = "concordium",
}
